import { StyleSheet } from 'aphrodite/no-important';

export default StyleSheet.create({
    text: {
        borderRadius: '50%',
        textAlign: 'center',
        color: '#ffffff',
        textTransform: 'uppercase'
    },
    eucalyptus: {
        backgroundColor: '#32a364'
    },
    islamicGreen: {
        backgroundColor: '#00a300'
    },
    chileanFire: {
        backgroundColor: '#da532c'
    },
    endeavour: {
        backgroundColor: '#2b5797'
    },
    persianPink: {
        backgroundColor: '#e773bd'
    },
    gigas: {
        backgroundColor: '#5e4b8b'
    },
    purpleHeart: {
        backgroundColor: '#603cba'
    },
    darkSpringGreen: {
        backgroundColor: '#1e7145'
    },
    persianGreen: {
        backgroundColor: '#00aba9'
    },
    dodgerBlue: {
        backgroundColor: '#2d89ef'
    },
    jordyBlue: {
        backgroundColor: '#6ba5e7'
    },
    hollywoodCerise: {
        backgroundColor: '#ff0097'
    },
    eminence: {
        backgroundColor: '#7e3878'
    },
    limerick: {
        backgroundColor: '#99b433'
    }
});



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/Initials/styles.js